/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway, Signs External
 * Partner\'s Bank Backoffice Gateway for Signs. External.
 *
 * The version of the OpenAPI document: 6.0
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface PidSignStatusV6
 */
export interface PidSignStatusV6 {
    /**
     * 
     * @type {string}
     * @memberof PidSignStatusV6
     */
    'pidUuid': string;
    /**
     * 
     * @type {SignStatusV6}
     * @memberof PidSignStatusV6
     */
    'signStatus': SignStatusV6;
}


/**
 * 
 * @export
 * @interface SignOperationSearchResultV6
 */
export interface SignOperationSearchResultV6 {
    /**
     * 
     * @type {string}
     * @memberof SignOperationSearchResultV6
     */
    'operationUuid': string;
    /**
     * Type of the sign operation. Known values are defined in `SignOperationType` schema, but it is not guaranteed that known value will be returned. 
     * @type {string}
     * @memberof SignOperationSearchResultV6
     */
    'operation': string;
    /**
     * 
     * @type {SignOperationStatusV6}
     * @memberof SignOperationSearchResultV6
     */
    'operationStatus': SignOperationStatusV6;
    /**
     * 
     * @type {Array<PidSignStatusV6>}
     * @memberof SignOperationSearchResultV6
     */
    'pidSignStatusList': Array<PidSignStatusV6>;
    /**
     * 
     * @type {string}
     * @memberof SignOperationSearchResultV6
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SignOperationSearchResultV6
     */
    'expiration': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SignOperationStatusV6 = {
    CANCELED: 'CANCELED',
    CANCELLING: 'CANCELLING',
    DONE: 'DONE',
    EXPIRED: 'EXPIRED',
    EXPIRING: 'EXPIRING',
    PROCESSING: 'PROCESSING',
    REFUSED: 'REFUSED',
    WAITING_FOR_SIGN: 'WAITING_FOR_SIGN'
} as const;

export type SignOperationStatusV6 = typeof SignOperationStatusV6[keyof typeof SignOperationStatusV6];


/**
 * 
 * @export
 * @enum {string}
 */

export const SignOperationTypeV6 = {
    ACTIVATION_CHILD_APP: 'ACTIVATION_CHILD_APP',
    CREATE_PSD2_PAYMENT_ORDER: 'CREATE_PSD2_PAYMENT_ORDER',
    CREATE_PAYMENT_ORDER: 'CREATE_PAYMENT_ORDER',
    CREATE_CHILD_PAYMENT_ORDER: 'CREATE_CHILD_PAYMENT_ORDER',
    CREATE_CHALLENGE_PAYMENT_ORDER: 'CREATE_CHALLENGE_PAYMENT_ORDER',
    ACCOUNT_LIMIT_SET: 'ACCOUNT_LIMIT_SET',
    CREATE_PSD2_REGULAR_STANDING_ORDER: 'CREATE_PSD2_REGULAR_STANDING_ORDER',
    CREATE_REGULAR_STANDING_ORDER: 'CREATE_REGULAR_STANDING_ORDER',
    CREATE_SAVINGS_GOAL_STANDING_ORDER: 'CREATE_SAVINGS_GOAL_STANDING_ORDER',
    UPDATE_STANDING_ORDER: 'UPDATE_STANDING_ORDER',
    UPDATE_PSD2_STANDING_ORDER: 'UPDATE_PSD2_STANDING_ORDER',
    DELETE_STANDING_ORDER: 'DELETE_STANDING_ORDER',
    DELETE_PSD2_STANDING_ORDER: 'DELETE_PSD2_STANDING_ORDER',
    DEACTIVATE_STANDING_ORDER: 'DEACTIVATE_STANDING_ORDER',
    REACTIVATE_STANDING_ORDER: 'REACTIVATE_STANDING_ORDER',
    CREATE_DIRECT_DEBIT: 'CREATE_DIRECT_DEBIT',
    UPDATE_DIRECT_DEBIT: 'UPDATE_DIRECT_DEBIT',
    DELETE_DIRECT_DEBIT: 'DELETE_DIRECT_DEBIT',
    CREATE_POCKET_MONEY: 'CREATE_POCKET_MONEY',
    UPDATE_POCKET_MONEY: 'UPDATE_POCKET_MONEY',
    DELETE_POCKET_MONEY: 'DELETE_POCKET_MONEY',
    CREATE_SIPO: 'CREATE_SIPO',
    UPDATE_SIPO: 'UPDATE_SIPO',
    DELETE_SIPO: 'DELETE_SIPO',
    BUNDLE_CHANGE: 'BUNDLE_CHANGE',
    CREATE_PRODUCT_SAVINGS_ACCOUNT_BASIC: 'CREATE_PRODUCT_SAVINGS_ACCOUNT_BASIC',
    CREATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY: 'CREATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY',
    CREATE_PRODUCT_CURRENT_ACCOUNT_BASIC: 'CREATE_PRODUCT_CURRENT_ACCOUNT_BASIC',
    CREATE_PRODUCT_PROTECTED_ACCOUNT: 'CREATE_PRODUCT_PROTECTED_ACCOUNT',
    CREATE_PRODUCT_CURRENT_ACCOUNT_CHILD: 'CREATE_PRODUCT_CURRENT_ACCOUNT_CHILD',
    CREATE_PRODUCT_CURRENT_ACCOUNT_SHARED: 'CREATE_PRODUCT_CURRENT_ACCOUNT_SHARED',
    CREATE_PRODUCT_SAVINGS_ACCOUNT_SHARED: 'CREATE_PRODUCT_SAVINGS_ACCOUNT_SHARED',
    CREATE_PRODUCT_SAVINGS_ACCOUNT_CHILD: 'CREATE_PRODUCT_SAVINGS_ACCOUNT_CHILD',
    CHANGE_PRODUCT_SAVINGS_ACCOUNT_CHILD: 'CHANGE_PRODUCT_SAVINGS_ACCOUNT_CHILD',
    TERMINATE_ACCOUNT: 'TERMINATE_ACCOUNT',
    ADD_DISPONENT_TO_BANK_CHILD: 'ADD_DISPONENT_TO_BANK_CHILD',
    REMOVE_DISPONENT_FROM_BANK_CHILD: 'REMOVE_DISPONENT_FROM_BANK_CHILD',
    ACTIVATE_CARD: 'ACTIVATE_CARD',
    CARDS_ACS_AUTHENTICATION_APPROVE: 'CARDS_ACS_AUTHENTICATION_APPROVE',
    PREPARE_SDD_PAYLOAD: 'PREPARE_SDD_PAYLOAD',
    CHANGE_CUSTOM_ACCOUNT_NAME: 'CHANGE_CUSTOM_ACCOUNT_NAME',
    CHANGE_ACCOUNT_SETTINGS: 'CHANGE_ACCOUNT_SETTINGS',
    CREATE_PRODUCTS_FIP_ONBOARDING: 'CREATE_PRODUCTS_FIP_ONBOARDING',
    CREATE_TREASURY_PAYMENT: 'CREATE_TREASURY_PAYMENT',
    STAMP_APS_LOAN_DOCUMENT: 'STAMP_APS_LOAN_DOCUMENT',
    CARDS_TOKEN_INAPP_VERIFICATION: 'CARDS_TOKEN_INAPP_VERIFICATION',
    CREATE_CHILD_REGULAR_STANDING_ORDER: 'CREATE_CHILD_REGULAR_STANDING_ORDER',
    UPDATE_CHILD_REGULAR_STANDING_ORDER: 'UPDATE_CHILD_REGULAR_STANDING_ORDER',
    CREATE_CHILD_DIRECT_DEBIT: 'CREATE_CHILD_DIRECT_DEBIT',
    UPDATE_CHILD_DIRECT_DEBIT: 'UPDATE_CHILD_DIRECT_DEBIT',
    REACTIVATE_CHILD_REGULAR_STANDING_ORDER: 'REACTIVATE_CHILD_REGULAR_STANDING_ORDER',
    CHANGE_SAVINGS_ACCOUNT_BASIC_PARAMETERS: 'CHANGE_SAVINGS_ACCOUNT_BASIC_PARAMETERS',
    CHANGE_SAVINGS_ACCOUNT_CHILD_PARAMETERS: 'CHANGE_SAVINGS_ACCOUNT_CHILD_PARAMETERS',
    CHANGE_SAVINGS_ACCOUNT_SHARED_PARAMETERS: 'CHANGE_SAVINGS_ACCOUNT_SHARED_PARAMETERS',
    CREATE_MOBILITY: 'CREATE_MOBILITY',
    CREATE_PAYMENT_ORDER_FROM_FIP: 'CREATE_PAYMENT_ORDER_FROM_FIP',
    CREATE_STANDING_ORDER_FROM_FIP: 'CREATE_STANDING_ORDER_FROM_FIP',
    TERMINATE_PRODUCT_PROTECTED_ACCOUNT_4_EYES: 'TERMINATE_PRODUCT_PROTECTED_ACCOUNT_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_BASIC_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_BASIC_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_CHILD_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_CHILD_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_SHARED_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_SHARED_4_EYES',
    TERMINATE_PRODUCT_SAVINGS_ACCOUNT_BASIC_4_EYES: 'TERMINATE_PRODUCT_SAVINGS_ACCOUNT_BASIC_4_EYES',
    TERMINATE_PRODUCT_SAVINGS_ACCOUNT_CHILD_4_EYES: 'TERMINATE_PRODUCT_SAVINGS_ACCOUNT_CHILD_4_EYES',
    TERMINATE_PRODUCT_SAVINGS_ACCOUNT_SHARED_4_EYES: 'TERMINATE_PRODUCT_SAVINGS_ACCOUNT_SHARED_4_EYES',
    TERMINATE_PRODUCT_TERM_DEPOSIT_4_EYES: 'TERMINATE_PRODUCT_TERM_DEPOSIT_4_EYES',
    CREATE_SEPA_PAYMENT: 'CREATE_SEPA_PAYMENT',
    CREATE_ZPS_PAYMENT: 'CREATE_ZPS_PAYMENT',
    CANCEL_PAYMENT_ORDER: 'CANCEL_PAYMENT_ORDER',
    CARDS_3_DS_REQUEST: 'CARDS_3_DS_REQUEST',
    CARDS_SET_LIMIT: 'CARDS_SET_LIMIT',
    UPSERT_SWEEP: 'UPSERT_SWEEP',
    DEACTIVATE_SWEEP: 'DEACTIVATE_SWEEP',
    CREATE_ODOO_PAYMENT: 'CREATE_ODOO_PAYMENT',
    CREATE_PRODUCT_SUPERSAVINGS: 'CREATE_PRODUCT_SUPERSAVINGS',
    CHANGE_PRODUCT_SUPERSAVINGS: 'CHANGE_PRODUCT_SUPERSAVINGS',
    TERMINATE_PRODUCT_SUPERSAVINGS: 'TERMINATE_PRODUCT_SUPERSAVINGS',
    CREATE_PAYMENT_TEMPLATE: 'CREATE_PAYMENT_TEMPLATE',
    UPDATE_PAYMENT_TEMPLATE: 'UPDATE_PAYMENT_TEMPLATE',
    DELETE_PAYMENT_TEMPLATE: 'DELETE_PAYMENT_TEMPLATE',
    CREATE_EXCHANGE_ORDER: 'CREATE_EXCHANGE_ORDER',
    CHILD_ACCOUNT_TRANSITION: 'CHILD_ACCOUNT_TRANSITION',
    EA_LONGTERM_TRAVEL_INSURANCE_CREATE: 'EA_LONGTERM_TRAVEL_INSURANCE_CREATE',
    EA_LONGTERM_TRAVEL_INSURANCE_WITHDRAW: 'EA_LONGTERM_TRAVEL_INSURANCE_WITHDRAW',
    EA_LONGTERM_TRAVEL_INSURANCE_TERMINATION: 'EA_LONGTERM_TRAVEL_INSURANCE_TERMINATION',
    CREATE_PSD2_SEPA_PAYMENT: 'CREATE_PSD2_SEPA_PAYMENT',
    CREATE_PSD2_ZPS_PAYMENT: 'CREATE_PSD2_ZPS_PAYMENT',
    CREATE_CRYPTO_ACCOUNT: 'CREATE_CRYPTO_ACCOUNT',
    SELL_CRYPTO: 'SELL_CRYPTO',
    BUY_CRYPTO: 'BUY_CRYPTO',
    CREATE_TREASURY_FOREIGN_PAYMENT: 'CREATE_TREASURY_FOREIGN_PAYMENT',
    CREATE_PRODUCT_TERM_DEPOSIT: 'CREATE_PRODUCT_TERM_DEPOSIT',
    CANCEL_CONTRACT: 'CANCEL_CONTRACT'
} as const;

export type SignOperationTypeV6 = typeof SignOperationTypeV6[keyof typeof SignOperationTypeV6];


/**
 * 
 * @export
 * @interface SignOperationV6
 */
export interface SignOperationV6 {
    /**
     * 
     * @type {string}
     * @memberof SignOperationV6
     */
    'operationUuid': string;
    /**
     * Type of the sign operation. Known values are defined in `SignOperationType` schema, but it is not guaranteed that known value will be returned. 
     * @type {string}
     * @memberof SignOperationV6
     */
    'operation': string;
    /**
     * 
     * @type {SignOperationStatusV6}
     * @memberof SignOperationV6
     */
    'operationStatus': SignOperationStatusV6;
    /**
     * 
     * @type {Array<PidSignStatusV6>}
     * @memberof SignOperationV6
     */
    'pidSignStatusList': Array<PidSignStatusV6>;
    /**
     * 
     * @type {string}
     * @memberof SignOperationV6
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof SignOperationV6
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SignOperationV6
     */
    'expiration': string;
}


/**
 * 
 * @export
 * @interface SignOperationsSearchFilterV6
 */
export interface SignOperationsSearchFilterV6 {
    /**
     * 
     * @type {string}
     * @memberof SignOperationsSearchFilterV6
     */
    'pidUuid': string;
    /**
     * 
     * @type {Array<SignOperationTypeV6>}
     * @memberof SignOperationsSearchFilterV6
     */
    'operationList': Array<SignOperationTypeV6>;
    /**
     * 
     * @type {Array<SignOperationStatusV6>}
     * @memberof SignOperationsSearchFilterV6
     */
    'operationStatusList': Array<SignOperationStatusV6>;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SignOperationsSearchFilterV6
     */
    'pageable': PageableV1x0;
}
/**
 * 
 * @export
 * @interface SignOperationsSearchResultV6
 */
export interface SignOperationsSearchResultV6 {
    /**
     * 
     * @type {Array<SignOperationSearchResultV6>}
     * @memberof SignOperationsSearchResultV6
     */
    'content': Array<SignOperationSearchResultV6>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof SignOperationsSearchResultV6
     */
    'pageable'?: PageableResponseV1x0;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SignStatusV6 = {
    CANCELED: 'CANCELED',
    IDENTIFICATION: 'IDENTIFICATION',
    NOT_READY: 'NOT_READY',
    READY: 'READY',
    REPLACED_BY_ANOTHER: 'REPLACED_BY_ANOTHER',
    SIGNED: 'SIGNED',
    WAITING_FOR_OTHERS: 'WAITING_FOR_OTHERS'
} as const;

export type SignStatusV6 = typeof SignStatusV6[keyof typeof SignStatusV6];




/**
 * SignsApi - axios parameter creator
 * @export
 */
export const SignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve available operations to be used in a filter.
         * @param {string} clientPidUuid 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSignOperationsV6: async (clientPidUuid: string, xCorrelationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getAvailableSignOperationsV6', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-signs-external/v6/operations/available-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sign operation specified by its UUID.
         * @param {string} clientPidUuid 
         * @param {string} operationUuid 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignOperationV6: async (clientPidUuid: string, operationUuid: string, xCorrelationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getSignOperationV6', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'operationUuid' is not null or undefined
            assertParamExists('getSignOperationV6', 'operationUuid', operationUuid)
            const localVarPath = `/bank-backofficegateway-signs-external/v6/operations/{operationUuid}`
                .replace(`{${"operationUuid"}}`, encodeURIComponent(String(operationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for sign operations using filter.
         * @param {SignOperationsSearchFilterV6} signOperationsSearchFilterV6 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSignOperationsV6: async (signOperationsSearchFilterV6: SignOperationsSearchFilterV6, xCorrelationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signOperationsSearchFilterV6' is not null or undefined
            assertParamExists('searchSignOperationsV6', 'signOperationsSearchFilterV6', signOperationsSearchFilterV6)
            const localVarPath = `/bank-backofficegateway-signs-external/v6/operations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signOperationsSearchFilterV6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignsApi - functional programming interface
 * @export
 */
export const SignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve available operations to be used in a filter.
         * @param {string} clientPidUuid 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSignOperationsV6(clientPidUuid: string, xCorrelationId?: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SignOperationTypeV6>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSignOperationsV6(clientPidUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get sign operation specified by its UUID.
         * @param {string} clientPidUuid 
         * @param {string} operationUuid 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignOperationV6(clientPidUuid: string, operationUuid: string, xCorrelationId?: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignOperationV6>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignOperationV6(clientPidUuid, operationUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search for sign operations using filter.
         * @param {SignOperationsSearchFilterV6} signOperationsSearchFilterV6 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSignOperationsV6(signOperationsSearchFilterV6: SignOperationsSearchFilterV6, xCorrelationId?: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignOperationsSearchResultV6>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSignOperationsV6(signOperationsSearchFilterV6, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignsApi - factory interface
 * @export
 */
export const SignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignsApiFp(configuration)
    return {
        /**
         * Retrieve available operations to be used in a filter.
         * @param {SignsApiGetAvailableSignOperationsV6Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSignOperationsV6(requestParameters: SignsApiGetAvailableSignOperationsV6Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<Array<SignOperationTypeV6>> {
            return localVarFp.getAvailableSignOperationsV6(requestParameters.clientPidUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get sign operation specified by its UUID.
         * @param {SignsApiGetSignOperationV6Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignOperationV6(requestParameters: SignsApiGetSignOperationV6Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SignOperationV6> {
            return localVarFp.getSignOperationV6(requestParameters.clientPidUuid, requestParameters.operationUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Search for sign operations using filter.
         * @param {SignsApiSearchSignOperationsV6Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSignOperationsV6(requestParameters: SignsApiSearchSignOperationsV6Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SignOperationsSearchResultV6> {
            return localVarFp.searchSignOperationsV6(requestParameters.signOperationsSearchFilterV6, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAvailableSignOperationsV6 operation in SignsApi.
 * @export
 * @type SignsApiGetAvailableSignOperationsV6Request
 */
export type SignsApiGetAvailableSignOperationsV6Request = {
    /**
     * 
     * @type {string}
     * @memberof SignsApiGetAvailableSignOperationsV6
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {string}
     * @memberof SignsApiGetAvailableSignOperationsV6
     */
    readonly xCorrelationId?: string
}

/**
 * Request parameters for getSignOperationV6 operation in SignsApi.
 * @export
 * @type SignsApiGetSignOperationV6Request
 */
export type SignsApiGetSignOperationV6Request = {
    /**
     * 
     * @type {string}
     * @memberof SignsApiGetSignOperationV6
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {string}
     * @memberof SignsApiGetSignOperationV6
     */
    readonly operationUuid: string

    /**
     * 
     * @type {string}
     * @memberof SignsApiGetSignOperationV6
     */
    readonly xCorrelationId?: string
}

/**
 * Request parameters for searchSignOperationsV6 operation in SignsApi.
 * @export
 * @type SignsApiSearchSignOperationsV6Request
 */
export type SignsApiSearchSignOperationsV6Request = {
    /**
     * 
     * @type {SignOperationsSearchFilterV6}
     * @memberof SignsApiSearchSignOperationsV6
     */
    readonly signOperationsSearchFilterV6: SignOperationsSearchFilterV6

    /**
     * 
     * @type {string}
     * @memberof SignsApiSearchSignOperationsV6
     */
    readonly xCorrelationId?: string
}

/**
 * SignsApi - object-oriented interface
 * @export
 * @class SignsApi
 * @extends {BaseAPI}
 */
export class SignsApi extends BaseAPI {
    /**
     * Retrieve available operations to be used in a filter.
     * @param {SignsApiGetAvailableSignOperationsV6Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignsApi
     */
    public getAvailableSignOperationsV6(requestParameters: SignsApiGetAvailableSignOperationsV6Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return SignsApiFp(this.configuration).getAvailableSignOperationsV6(requestParameters.clientPidUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sign operation specified by its UUID.
     * @param {SignsApiGetSignOperationV6Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignsApi
     */
    public getSignOperationV6(requestParameters: SignsApiGetSignOperationV6Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return SignsApiFp(this.configuration).getSignOperationV6(requestParameters.clientPidUuid, requestParameters.operationUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for sign operations using filter.
     * @param {SignsApiSearchSignOperationsV6Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignsApi
     */
    public searchSignOperationsV6(requestParameters: SignsApiSearchSignOperationsV6Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return SignsApiFp(this.configuration).searchSignOperationsV6(requestParameters.signOperationsSearchFilterV6, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


